import cn from 'classnames'
import React, { FC, useState, useEffect, useRef, useMemo, SyntheticEvent } from 'react'
import s from './Form.module.css'
import { usePC } from '@contexts/Form/FormContext'

interface IForm {
    index: number
    onSubmit: (() => void) | any
    id: string
    className?: string
    noValidate?: boolean
    isExtraForm?: boolean
}
const Form: FC<IForm> = ({ children, index, onSubmit, id, className, noValidate = true, isExtraForm }) => {
    const currentForm = useRef(null)
    const {
        formIndex,
        setFormCurrent
    } = usePC()

    useEffect(() => {
        if (formIndex == index && !isExtraForm) {
            setFormCurrent(currentForm.current)
        }
    }, [formIndex])

    return <form
        noValidate={noValidate}
        ref={currentForm}
        id={id}
        className={cn(s.root, className, { [s.hide]: formIndex != index })}
        onSubmit={(e) => {
            e.preventDefault();
            onSubmit(e);
        }}
    >
        {children}
    </form>
}
export default Form